
import React, { PureComponent } from "react";
import { translate } from "react-i18next";

import BattleTeamsList from "../BattleTeamsList/BattleTeamsList";

import { ErrorLoad, Table, TableBody, StepCSSTransitionGroup } from "@wg/wows-react-uikit";

import styles from "./ClanBattlesTable.scss";
import { t } from "../../../helpers/localization";

import ClanBattlesTableHead from "./ClanBattlesTableHead";
import ClanBattlesTableItem from "./ClanBattlesTableItem";

export type IClanBattlesTable_Props = {
  battlesList: Array<any>;
  stickyContainerId: string;
  selectedBattle: number;
  isFetching: boolean;
  isError: boolean;
  errorMessage: string;
  seasonType: string;

  onClickBattle: (id: number) => void;
};
export type IClanBattlesTable_State = {};

class ClanBattlesTable extends PureComponent<IClanBattlesTable_Props, IClanBattlesTable_State> {


  renderBattlesList() {
    const battles = this.props.battlesList;
    const isFetching = this.props.isFetching

    if (isFetching) {
      return (
        <StepCSSTransitionGroup level={1}>
          <ErrorLoad message={t('Идёт загрузка истории боёв')} t={t} />
        </StepCSSTransitionGroup>
      )
    }
    if (!battles.length) {
      return <StepCSSTransitionGroup level={1}>
        <ErrorLoad message={t('В настоящее время твой клан не сыграл ни одного боя.')} t={t} />
      </StepCSSTransitionGroup>;
    }

    if (this.props.isError) {
      return <StepCSSTransitionGroup level={1}>
        <ErrorLoad message={this.props.errorMessage} t={t} />
      </StepCSSTransitionGroup>;
    }

    const battlesRows = battles.map((battle, index) => {
      let userTeam = battle.teams[0];
      let enemyTeam = battle.teams[1];
      return <div key={index} onClick={() => {
        if (userTeam.players.length || enemyTeam.players.length) this.props.onClickBattle(battle.id);
      }}>
        <ClanBattlesTableItem battleId={battle.id} date={battle.finished_at} ratingDelta={userTeam.rating_delta} result={userTeam.result} arrow={userTeam.stage ? userTeam.stage.type : ''} progress={userTeam.stage ? userTeam.stage.progress : []} map={battle.map ? battle.map.name : '-'} enemyRealm={enemyTeam.claninfo.realm} enemyName={enemyTeam.claninfo.name} enemyTag={enemyTeam.claninfo.tag} enemyTagColor={enemyTeam.claninfo.color} enemyTeamNumber={enemyTeam.team_number} isActive={battle.id === this.props.selectedBattle} target={userTeam.stage ? userTeam.stage.target : ''} seasonType={this.props.seasonType} />
        <BattleTeamsList userTeam={userTeam} enemyTeam={enemyTeam} isShow={battle.id === this.props.selectedBattle} />
      </div>;
    });

    return <StepCSSTransitionGroup level={1}>
      <TableBody key="table-body">
        {battlesRows}
      </TableBody>
    </StepCSSTransitionGroup>;
  }

  render() {
    return <div className={styles.container}>
      <Table isFetching={this.props.isFetching} stickyContainerId={this.props.stickyContainerId}>
        <ClanBattlesTableHead stickyContainerId={this.props.stickyContainerId} />
        {this.renderBattlesList()}
      </Table>
    </div>;
  }
}

export default translate()(ClanBattlesTable);